import { dashboard } from "./dashboard";
import { payments } from "./payments";
import { chat } from "./chat";
import { document_center } from "./document-center";
import { special_invoices } from "./special-invoices";
import { tax_validation } from "./tax-validation";
import { reconcile } from "./reconcile";
import { reports } from "./reports";
import { financial_documents } from "./financial-documents";
import { cobrowse } from "./cobrowse";
import { core } from "./core";
import { digital_document_center } from "./digital-document-center"

export * from "./dashboard";
export * from "./payments";
export * from "./chat";
export * from "./document-center";
export * from "./special-invoices";
export * from "./reconcile";
export * from "./reports";
export * from "./financial-documents";
export * from "./core";
export * from "./digital-document-center";

export const containers = [
  { key: "dashboard", value: dashboard },
  { key: "payments", value: payments },
  { key: "chatBot", value: chat },
  { key: "document_center", value: document_center },
  { key: "special_invoices", value: special_invoices },
  { key: "tax_validation", value: tax_validation },
  { key: "reconcile", value: reconcile },
  { key: "reports", value: reports },
  { key: "financial_documents", value: financial_documents },
  { key: "cobrowse", value: cobrowse },
  { key: "core", value: core },
  { key: "digital_document_center", value: digital_document_center }
];
